var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52395 11.7392H27.7392C28.0736 11.7392 28.3943 11.872 28.6307 12.1085C28.8672 12.3449 29 12.6656 29 13C29 13.3343 28.8672 13.655 28.6307 13.8915C28.3943 14.1279 28.0736 14.2607 27.7392 14.2607H2.52395C2.18957 14.2607 1.86889 14.1279 1.63245 13.8915C1.39601 13.655 1.26318 13.3343 1.26318 13C1.26318 12.6656 1.39601 12.3449 1.63245 12.1085C1.86889 11.872 2.18957 11.7392 2.52395 11.7392Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04574 13L13.5025 23.4543C13.7393 23.691 13.8723 24.0121 13.8723 24.3469C13.8723 24.6817 13.7393 25.0028 13.5025 25.2395C13.2658 25.4763 12.9447 25.6093 12.6099 25.6093C12.2751 25.6093 11.954 25.4763 11.7173 25.2395L0.370397 13.8927C0.252986 13.7755 0.159834 13.6364 0.0962753 13.4833C0.0327165 13.3301 0 13.1659 0 13C0 12.8342 0.0327165 12.67 0.0962753 12.5168C0.159834 12.3637 0.252986 12.2245 0.370397 12.1074L11.7173 0.760544C11.954 0.523806 12.2751 0.390808 12.6099 0.390808C12.9447 0.390808 13.2658 0.523806 13.5025 0.760544C13.7393 0.997281 13.8723 1.31837 13.8723 1.65316C13.8723 1.98796 13.7393 2.30905 13.5025 2.54579L3.04574 13Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.346820d00d12b46c27b73b2ee5e33af9.svg";
export { ForwardRef as ReactComponent };